export const IS_OLD_USER_COOKIE = 'is_old_user';
export const PLP_PRODUCTS_PER_PAGE = 18;
export const HEADER_HEIGHT = 131;
